import { defineStyleConfig } from '@chakra-ui/react';

export const FormLabelTheme = defineStyleConfig({
  baseStyle: {
    fontSize: 'xs',
  },
});


